/**
 * Report and document types.
 */

import { BaseEntity } from './base';
import { Visit } from './visit';

// ============================================================================
// REPORT
// ============================================================================

export interface Report extends BaseEntity {
  status: ReportStatus;
  report: string;
  visitId: string;
  caseId: string;
  supervisorId: string;
  accountId: string;
  visit?: Visit;
  reportTemplateId?: string;
  signatureUrl?: string;
  completedDocumentPath?: string;
  reportPDFPath?: string;
  updatedBy?: string;
  images?: string[];
  isAIGenerated?: boolean;
}

export type ReportStatus = 'pending' | 'completed' | 'approved' | 'rejected' | 'draft' | 'signed';

export const REPORT_STATUS_LABELS: Record<ReportStatus, string> = {
  pending: "Pending",
  completed: "Completed",
  approved: "Approved",
  rejected: "Rejected",
  draft: "Draft",
  signed: "Signed",
};

// ============================================================================
// PDF REPORT
// ============================================================================

export interface PDFReport extends BaseEntity {
  reportId: string;
  visitId: string;
  accountId: string;
  filename: string;
  url: string;
  size: number;
  status: PDFReportStatus;
  metadata?: Record<string, unknown>;
}

export type PDFReportStatus = 'generating' | 'completed' | 'failed';

// ============================================================================
// DOCUMENT
// ============================================================================

export interface Document extends BaseEntity {
  parentId: string;
  caseId: string;
  accountId: string;
  type: DocumentType;
  filename: string;
  url: string;
  contentType: string;
  size: number;
  metadata?: Record<string, unknown>;
}

export type DocumentType = 'agreement' | 'court_order' | 'photo' | 'report' | 'other';
